<app-loader *ngIf="isLoading"></app-loader>
<app-header [pageTitle]="currentPageName"></app-header>
<router-outlet></router-outlet>
<app-footer [pageTitle]="currentPageName"></app-footer>
